// extracted by mini-css-extract-plugin
export var banner = "_h2-0";
export var closeButton = "_h2-2";
export var greenCheckmark = "_h2-3";
export var hereLink = "_h2-4";
export var titleIcon = "_h2-1";